module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/Black-Beauty.d6d79c2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/Black-Beauty.jpg
// module id = 9Z9a
// module chunks = 0